import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import { Empty, Upload, Progress, Card, Button, Alert, Tag } from 'antd';
import Lottie from 'lottie-react';

export const XThemeEmptySimulateEhr = styled(Empty)`
	width: 100%;
	position: relative;
	border-radius: 20px;
	border-style: solid;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	background: ${({ theme }) => theme.colors.white};
	padding: 30px 15px;
	.ant-empty-image {
		height: auto;
		img {
			height: 250px;
		}
	}
`;

export const XThemeBulkUpload = styled(Upload)`
	width: 100%;
	position: relative;
`;

export const XThemeBulkWrapper = styled.div`
	width: 100%;
	position: relative;
	.ant-upload-drag-container {
		padding: 5px 15px;
		.ant-upload-drag-icon {
			margin-bottom: 10px !important;
		}
		.ant-upload-text {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			font-weight: 400 !important;
			font-size: 15px !important;
			line-height: 24px !important;
			letter-spacing: -0.02em !important;
			color: ${({ theme }) => theme.colors.themeColor1} !important;
			span {
				color: ${({ theme }) => theme.colors.themeColor8};
			}
		}
		.ant-upload-hint {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			margin-bottom: 0px !important;
			font-weight: 400 !important;
			font-size: 13px !important;
			line-height: 20px !important;
			color: rgba(33, 34, 38, 0.5) !important;
		}
	}
	.ant-upload-drag {
		background: #f2f8fa !important;
		&:hover {
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
	.has-error .ant-upload-drag {
		background: rgba(201, 37, 25, 0.02) !important;
		border: 1px solid rgba(201, 37, 25, 0.1) !important;
	}
`;

export const XThemeCardUploading = styled(Card)`
	width: 100%;
	position: relative;
	text-align: center;
	background: #f2f8fa !important;
	.title {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 400 !important;
		font-size: 15px !important;
		line-height: 24px !important;
		letter-spacing: -0.02em !important;
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		span {
			color: ${({ theme }) => theme.colors.themeColor8};
		}
	}
	.title2 {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		margin-bottom: 0px !important;
		font-weight: 400 !important;
		font-size: 13px !important;
		line-height: 20px !important;
		color: rgba(33, 34, 38, 0.5) !important;
	}
	@media only screen and (max-width: 768px) {
	}
`;

export const XThemeCSVLottie = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 100px;
	margin: 0px auto;
	@media only screen and (max-width: 768px) {
		width: 100px;
		position: relative;
		margin: 0px auto;
	}
`;

export const XThemePDFProgress = styled(Progress)`
	width: 100%;
	position: relative;
	.ant-progress-inner {
		background: ${({ theme }) => theme.colors.white};
	}
	.ant-progress-bg {
		background: ${({ theme }) => theme.colors.themeColor8};
	}
	@media only screen and (max-width: 768px) {
	}
`;

export const XThemeCancelProgressBTN = styled(Button)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 8px;
	font-weight: 500;
	font-size: 12px;
	line-height: 18px;
	color: ${({ theme }) => theme.colors.themeColor8};
	box-shadow: none;
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		color: ${({ theme }) => theme.colors.white} !important;
	}
	@media only screen and (max-width: 768px) {
	}
`;

export const XThemeErrors = styled(Alert)`
	border-radius: 10px;
	.ant-alert-message {
		font-weight: 400;
		font-size: 13px;
		line-height: 32px;
		letter-spacing: -0.02em;
	}
	.ant-alert-error {
		background: rgba(201, 37, 25, 0.02);
		border: 1px solid rgba(201, 37, 25, 0.1);
		color: #c92519;
	}
	@media only screen and (max-width: 768px) {
	}
`;

export const XThemeBulkTags = styled(Tag)`
	border-radius: 20px;
	font-family: ${({ theme }) => theme.colors.fontInter} !important;
	font-size: 12px !important;
	line-height: 24px !important;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.36px;
	padding-left: 22px;
	padding-right: 10px;
	border: none;
	&:before {
		content: '\u{25CF}';
		position: absolute;
		top: 0px;
		left: 10px;
		font-size: 10px;
	}
	border: none;
	&.processing {
		background: #fbead4 !important;
		color: #ed982a !important;
	}
	&.completed {
		background: #d7f0e5 !important;
		color: #36b37e !important;
	}
	&.pending {
		background: #fff8d9 !important;
		color: #cfae2a !important;
	}
	&.creating_simulation {
		background: #e6f7ff !important;
		color: #1890ff !important;
	}
	&.simulation_created {
		background: #d9f7be !important;
		color: #52c41a !important;
	}
	&.processing_simulation {
		background: #f0f5ff !important;
		color: #597ef7 !important;
	}
	&.failed {
		background: #ffccc7 !important;
		color: #ff4d4f !important;
	}
	&.partial {
		background: #fff1b8 !important;
		color: #faad14 !important;
	}
	&.retrying_simulation_creating {
		background: #ffd6e7 !important;
		color: #eb2f96 !important;
	}
	&.inputs_taken {
		background: #e8f5ff !important;
		color: #2b95d6 !important;
	}
	&.processing_inputs {
		background: #ebf5ec !important;
		color: #52c41a !important;
	}
	&.human_intervention {
		background: #d0ebff !important;
		color: #68a1cf !important;
	}
	&.inconclusive {
		background: #f2eaf6 !important;
		color: #957fd4 !important;
	}
	&.simulation_prepared {
		background: #d3f9d8 !important;
		color: #5eaa69 !important;
	}
	&.rejected,
	&.not_covered {
		background: #ffe2e5 !important;
		color: #e48383 !important;
	}
	@media only screen and (max-width: 767.99px) {
	}
`;

export const XThemeSimulateEhrDetailsCard = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 20px;
	border-style: solid;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	height: 100%;
	&.gradientBg {
		background: ${({ theme }) => theme.CQColors.white}
			url('../../images/batch-gradient-bg.svg') no-repeat bottom center !important;
		background-size: contain !important;
	}
	h1 {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 500 !important;
		font-size: 16px !important;
		line-height: 24px !important;
		letter-spacing: -0.02em !important;
		color: ${({ theme }) => theme.colors.themeColor1} !important;
	}
	p {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 400 !important;
		font-size: 13px !important;
		line-height: 20px !important;
		color: rgba(33, 34, 38, 0.5) !important;
	}
	@media only screen and (max-width: 768px) {
	}
`; 